import * as React from "react";
import { Spinner } from "@/components/ui/spinner";

interface PanelLoadingStateProps {
  message?: string;
}

export function PanelLoadingState({ message = "Loading…" }: PanelLoadingStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-12 text-slate-400">
      <Spinner size="md" />
      <p className="m-0 text-xs">{message}</p>
    </div>
  );
}
